import * as React from 'react';

import { AngularDirective } from '../../../common/react/components/AngularDirective';
import { MobileAppBanner } from '../../../mobile/components/MobileAppBanner';
import { AngularContext } from '../../../ts/factories/AngularContextFactory';
import { ProcessAndRemoveSamlQueryWrapper } from '../RouterHelpers/ProcessAndRemoveSamlQueryWrapper';
import { DefaultServerTitleWrapper } from './DefaultServerTitleWrapper';

const template = `<tb:login-site-picker />`;

export function SitePickerProvider(props: {angularContext: AngularContext}): JSX.Element {
  return (
    <DefaultServerTitleWrapper>
      <ProcessAndRemoveSamlQueryWrapper>
        <div>
          <MobileAppBanner />
        </div>
        <div>
          <AngularDirective
            angularContext={props.angularContext}
            template={template}
          />
        </div>
      </ProcessAndRemoveSamlQueryWrapper>
    </DefaultServerTitleWrapper>
  );
}
